export default __webpack_public_path__ + "./image/97b4a4572a494e56c3e36fbe582a7f11.png";